import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from './client.js';

/** A project's staff notepad. */
export interface ProjectNotes {
  content: string;
  updatedAt: string | null;
  updatedByEmail: string | null;
}

export function useProjectNotes(projectId: string) {
  return useQuery({
    queryKey: ['notes', projectId],
    queryFn: () =>
      apiFetch<{ notes: ProjectNotes }>(`/projects/${projectId}/notes`).then((r) => r.notes),
  });
}

export function useSaveProjectNotes(projectId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (content: string) =>
      apiFetch<{ notes: ProjectNotes }>(`/projects/${projectId}/notes`, {
        method: 'PUT',
        body: { content },
      }).then((r) => r.notes),
    onSuccess: (notes) => qc.setQueryData(['notes', projectId], notes),
  });
}
